export default __webpack_public_path__ + "static/media/menu.6e4a19ed.svg";